import { render, staticRenderFns } from "./stage-manage.vue?vue&type=template&id=0afcf312&scoped=true"
import script from "./stage-manage.vue?vue&type=script&lang=js"
export * from "./stage-manage.vue?vue&type=script&lang=js"
import style0 from "./stage-manage.vue?vue&type=style&index=0&id=0afcf312&prod&lang=less&scoped=true"
import style1 from "./stage-manage.vue?vue&type=style&index=1&id=0afcf312&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afcf312",
  null
  
)

export default component.exports